let catalogSnapshot = null;

export function setMarketsCatalogSnapshot(catalog) {
  catalogSnapshot = catalog;
}

export function getMarketsCatalogSnapshot() {
  return catalogSnapshot;
}
